import React, { useEffect, useState, useCallback } from "react";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Grid,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
  Typography,
} from "@mui/material";

import { TField, Page, MUITableD } from "components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useIsMountedRef, axios } from "utilities";
import { useSnackbar } from "notistack";

const PREFIX = 'Transactions';

const classes = {
  root: `${PREFIX}-root`,
  fields: `${PREFIX}-fields`,
  input: `${PREFIX}-input`
};

const Root = styled('div')(() => ({
  [`& .${classes.root}`]: {},
  [`& .${classes.fields}`]: {},

  [`& .${classes.input}`]: {
    display: "none",
  }
}));

function Transactions({
  data,
  /* error, helper, /* codes, */ handleConsUpdate,
  handleBalChangeCancel,
  balChangePopupVisibilty,
  handleChange,
  className,
  ...rest
}) {
  // const[pic, setPic] = useState (data.image);
  const params = useParams();

  const { t } = useTranslation("consumer");
  const { enqueueSnackbar } = useSnackbar();

  const [transdata, setTransdata] = useState([]);
  const isMountedRef = useIsMountedRef();

  const columns = [
    { label: t("Transaction Type"), name: "transactiontype" },
    { label: t("Date"), name: "transactiondate" },
    {
      label: t("Transaction Amount"),
      name: "transactionamount",
      options: {
        customBodyRender: (value) => {
          return (value / 100).toFixed(2);
        },
      },
    },
    { label: t("Points"), name: "points" },
    {
      label: t("New Balance"),
      name: "newbalance",
      options: {
        customBodyRender: (value) => {
          return (value / 100).toFixed(2);
        },
      },
    },
    { label: t("New Points"), name: "newpoints" },
  ];

  const handleAmtChangeSave = async () => {
    let amount = parseFloat(data.amount) || 0;
    let intAmt = parseInt((amount * 100).toFixed(0));
    let request = { consumerid: params.guid, transamount: intAmt };
    console.log(request);
    let url = "/api/consumerbalance";
    axios
      .post(url, request)
      .then((response) => {
        if (response.status === 200) {
          enqueueSnackbar("Update successful", { variant: "success" });
          getData();
          handleBalChangeCancel();
          handleConsUpdate();
        }
      })
      .catch((reason) => {
        console.log(reason);
        enqueueSnackbar("Error setting new balance: " + reason, {
          variant: "error",
        });
      });
  };

  const getData = useCallback(() => {
    axios.get("/api/consumertrans?guid=" + params.guid).then((response) => {
      if (isMountedRef.current) {
        setTransdata(response.data);
      }
    });
  }, [isMountedRef, params]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <Root>
      <Page className={classes.root} title={t("Transaction Overview")}>
        <Container maxWidth={false} className={classes.container}>
          <MUITableD title="" data={transdata} cols={columns} />
        </Container>
      </Page>
      <Dialog
        aria-labelledby="leave-popup-title"
        open={balChangePopupVisibilty.display}
      >
        <DialogTitle id="leave-popup-title">
          Change Balance of Customer {params.guid}
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom className={classes.dialogtypo}>
            Please enter an amount
          </Typography>
          <Grid
            container
            className={clsx(classes.root, className)}
            spacing={3}
            {...rest}
          >
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <TField
                label={t("Amount")}
                name="amount"
                value={data.amount /*  != null ? data.amount : "0.00" */}
                onChange={handleChange}
                ro={false}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBalChangeCancel} color="primary">
            Cancel
          </Button>
          <Button
            /* autoFocus */ onClick={handleAmtChangeSave}
            color="primary"
            variant="outlined"
          >
            Process Credit/Debit
          </Button>
        </DialogActions>
      </Dialog>
    </Root>
  );
}

Transactions.propTypes = {
  data: PropTypes.object.isRequired,
  error: PropTypes.object,
  helper: PropTypes.object,
  codes: PropTypes.array,
  handleChange: PropTypes.func,
  className: PropTypes.string,
  balChangePopupVisibilty: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBalChangeCancel: PropTypes.func,
  handleBalChangeSave: PropTypes.func,
};

export default Transactions;

// "data:image/jpeg;base64,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"
// style={{ maxWidth: "50px", maxHeight: "50px" }}
